import styled from 'styled-components';

export const ValidationError = styled.label`
    font-size: 14px;
    color: #c43227;
    width: 300px;
    margin-top: 5px;
`